module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/hall-list/plan-ceremony-lineup-tokai-3-c6deea3982e1e7a5085ae9e4e64fca5d.png";